import { track } from '@vercel/analytics';

export const trackEvent = (eventName, payload = {}) => {
	try {
		track(eventName, payload);
	} catch (_) {
		// no-op to avoid impacting UX when analytics is unavailable
	}

	if (typeof window !== 'undefined') {
		try {
			window.dispatchEvent(new CustomEvent('calcium:analytics', {
				detail: {
					eventName,
					payload
				}
			}));
		} catch (_) {
			// no-op
		}
	}
};
